import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../../axios/index";
import { Link, useLocation } from "react-router-dom";

import { UserContext } from "../../../Context/UserContextProvider";

// components
import HomeNavbar from "./../../HomeNavbar/HomeNavbar";
import parse from "html-react-parser";
import Footer from "../../Footer/Footer";

// styles
import styles from "./BlogDetail.module.css";
import Dstyles from "../../../Dashboard/Blogs/BlogDetailManagment/BlogDetailManagment.module.css";
import loaderStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

const BlogDetail = props => {
  const id = props.match.params.id;
  const { state } = useLocation();
  const [blogData, setBlogData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      const getApiData = await axios.get(`Article/bySlug/${state ? state.slug : id}`);
      setBlogData(getApiData.data.data);
      const seoData = getApiData.data.data.seoData;
      // console.log(seoData)
      setIsLoading(false);
    };
    getData();

    return () => {};
  }, [id, state]);

  return (
    <>
      <Helmet>
        <title>Azar Melk | آذر ملک</title>
      </Helmet>

      {isLoading ? (
        <div className={loaderStyles.loader_container}>
          <div className={loaderStyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar blogs />
            <div className="container py-3">
              <div className="w-100 position-relative d-flex flex-column justify-content-start flex-wrap align-items-start mt-3" dir="rtl">
                <Link to="/وبلاگ" className={styles.back_btn}>
                  برگشت به مقالات
                </Link>
                <div className="w-100 d-flex flex-column align-items-center justify-content-start flex-wrap">
                  <div className="w-100">
                    <img className={styles.blog_img} src={`https://backdev.azrmelk.com/magAssets/img/Articles/${blogData?.imageName}`} alt="blog-img" />
                  </div>
                  <div className="w-100 my-3 d-flex flex-wrap align-items-center justify-content-lg-between justify-content-start">
                    <div className="d-flex align-items-center justify-content-start p-3 mt-3 my-md-0 my-3">
                      <h4>{blogData?.title}</h4>
                    </div>
                    <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${styles.w_100}`}>
                      <div className="d-flex flex-column justify-content-center align-items-center mx-md-2 mx-1 my-1">
                        <img
                          className={`mb-2 ${Dstyles.profile_img}`}
                          loading="lazy"
                          src={`https://backdev.azrmelk.com/images/users/avatar/${blogData.userDto?.avatarName}`}
                          alt="profile"
                        />
                        <div className={Dstyles.header_sub_title}>{blogData?.ownerName}</div>
                      </div>
                      <span className={Dstyles.line}></span>
                      <div className="d-flex flex-column justify-content-center align-items-center mx-md-2 mx-1 my-1">
                        <div className={`d-flex align-items-center justify-content-center mb-2 ${Dstyles.bg_rounded}`}>
                          <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.3844 11.0985H10.5078" stroke="#323232" stroke-width="1.5" stroke-linecap="round" strokeLinejoin="round" />
                            <ellipse
                              cx="11.0109"
                              cy="10.5969"
                              rx="7.50313"
                              ry="7.50313"
                              stroke="#323232"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              strokeLinejoin="round"
                            />
                            <path d="M10.5106 11.0982V6.42773" stroke="#323232" stroke-width="1.5" stroke-linecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>

                        <div className={Dstyles.header_sub_title}>
                          {blogData.dateRelease && blogData?.dateRelease?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                        </div>
                      </div>
                      <span className={Dstyles.line}></span>
                      <div className="d-flex flex-column justify-content-center align-items-center mx-md-2 mx-1 my-1">
                        <div className={`d-flex align-items-center justify-content-center mb-2 ${Dstyles.bg_rounded}`}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.59813 10.3885C2.46729 10.146 2.46729 9.85185 2.59813 9.60935C4.17479 6.69352 7.08729 4.16602 9.99979 4.16602C12.9123 4.16602 15.8248 6.69352 17.4015 9.61018C17.5323 9.85268 17.5323 10.1468 17.4015 10.3893C15.8248 13.3052 12.9123 15.8327 9.99979 15.8327C7.08729 15.8327 4.17479 13.3052 2.59813 10.3885Z"
                              stroke="#323232"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11.7678 8.23223C12.7441 9.20854 12.7441 10.7915 11.7678 11.7678C10.7915 12.7441 9.20854 12.7441 8.23223 11.7678C7.25592 10.7915 7.25592 9.20854 8.23223 8.23223C9.20854 7.25592 10.7915 7.25592 11.7678 8.23223"
                              stroke="#323232"
                              stroke-width="1.4286"
                              stroke-linecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>

                        <div className={Dstyles.header_sub_title}>{blogData.visit && blogData?.visit?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="w-100 d-flex align-items-center justify-content-start p-3 mt-3">
                                    <h4>{blogData?.title}</h4>
                                </div>
                                <div className="w-100 d-flex flex-column align-items-start justify-content-center p-3">
                                    <p className={styles.blog_title}>
                                        {blogData?.ownerName}
                                    </p>
                                    <p className={styles.text_gray_sm}>
                                        تاریخ انتشار: {blogData.dateRelease && e2p(blogData?.dateRelease)}
                                    </p>
                                </div> */}
                  <div className="w-100 d-flex flex-column align-items-start justify-content-center px-md-5 px-3 text-wrap text-end">
                    {blogData?.aparatVideoUrl ? (
                      <div className="my-2 w-100">
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe
                          src={blogData.aparatVideoUrl}
                          className="w-100"
                          style={{
                            height: "550px",
                          }}
                          allowFullScreen="true"
                          webkitallowfullscreen="true"
                          mozallowfullscreen="true"></iframe>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="w-100 d-flex flex-column align-items-start justify-content-center px-md-5 px-3 text-wrap text-end">
                    {blogData?.body ? parse(`<body className=${styles.body_container}>${blogData?.body}</body>`) : parse("<p>متن بلاگ</p>")}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default BlogDetail;
